const locale = {
    locale: "es_ES",
    yearFormat: "YYYY",
    monthFormat: "MMMM",
    fieldDateFormat: "MMM dd yyyy",
    dayFormat: "D",
    monthBeforeYear: true,
};
export default locale;
